import { $api } from '@/shared/api/axiosInstance';

type Response = {
    provider: string;
    sub: string;
    uuid: string;
};

export const getParams = async () => {
    const url = '/api/auth/status';

    const res = await $api.get<Response>(url);

    return res.data;
};
